<template>
    <div class="app-inner">
         <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
           <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="onSubmit('ruleForm')"
            >
             {{$route.query.id ? '修改' : '保存'}}
           </el-button>
            </div>
             <div class="edit-from">
                    <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
            <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex align-cen">
                  <el-form-item label="岗位名称：" prop="name">
                    <el-input v-model="form.name" placeholder="请输入岗位名称" clearable></el-input>
                </el-form-item>
                   <el-form-item label="官网分类：" >
                     <el-checkbox-group v-model="checkList" @change="classSelectType">
                  <el-checkbox label="1">和隆优化官网</el-checkbox>
                  <el-checkbox label="2">和隆软件官网</el-checkbox>
              </el-checkbox-group>
                </el-form-item>
                     <el-form-item label="职位分类：" prop="classifyId">
                    <el-select v-model="form.classifyId" placeholder="选择职位分类">
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                   <el-form-item label="学历要求：" prop="degree">
                    <el-select v-model="form.degree" placeholder="选择学历要求">
                        <el-option
                        v-for="item in options1"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="工作类型：" prop="jobCategory">
                    <el-select v-model="form.jobCategory" placeholder="选择工作类型">
                        <el-option
                        v-for="item in options2"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="经验要求：" prop="experience">
                    <el-select v-model="form.experience" placeholder="选择经验要求">
                        <el-option
                        v-for="item in options3"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="招聘人数：" prop="headcount">
                    <el-input v-model="form.headcount" placeholder="请输入招聘人数" clearable></el-input>
                </el-form-item>
                   <el-form-item label="招聘需求：" prop="hiringNeeds">
                    <el-select v-model="form.hiringNeeds" placeholder="选择招聘需求">
                        <el-option
                        v-for="item in options4"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                  <el-form-item label="薪资范围：" prop="salaryRange">
                    <el-input v-model="form.salaryRange" placeholder="请输入薪资范围" clearable></el-input>
                </el-form-item>
                 <el-form-item label="工作地点：" prop="workplace">
                     <el-select v-model="form.workplace" multiple placeholder="请选择">
                        <el-option
                        v-for="item in optionsAll"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <!-- <el-cascader
                            size="large"
                            :options="optionsAll"
                            v-model="form.workplace"
                            placeholder="请选择城市(可多选)"
                            :show-all-levels="false"
                            :props="{multiple: true }"
                            @change="cityValueChange"
                            >
                     </el-cascader> -->
                    <!-- <el-input v-model="form.salaryRange" placeholder="请输入薪资范围" clearable></el-input> -->
                </el-form-item>
            </el-form>
             <div class="AppContent">
                  <div class="moreCanvas"
                     v-for="(item,index) in recruitList"
                    :key="index"
                    :id="'addCanvas'+index"
                    >
                         <div class="public-tit flex align-cen" style="margin-bottom:20px">
                        <div class="public-tit-list">
                            <i class="icon-al-database-fill"></i> {{item.title}}
                        </div>
                    </div>
                     <quillsTemplate  @sendStatus="emitFun" 
                     :propData="item.content"
                     :currindex="index"
                     :tempname="index"
                     :placeName="item.title"
                    :ref="'quillTemplate' + index"
                    ></quillsTemplate>
                  </div>
             </div>
             </div>
    </div>
</template>
<script>
import { jobClassify,editJob,getJob} from "@/api/index/index"  //人才岗位分类、人才岗位列表、新增修改人才岗位、岗位详情
import { provinceAndCityData,regionData, CodeToText, TextToCode } from 'element-china-area-data'  //省市区级联
import quillsTemplate from "@/components/quills";  //多富文本组件
export default {
    name:'addJob',
     components:{
        quillsTemplate,
    },
    data() {
        return {
             checkList:[],
            loading:false,
            selectedOptions: '',
            optionsAll:[
                {
                value: '北京',
                label: '北京'
                }, {
                value: '南京',
                label: '南京'
                },{
                value: '济南',
                label: '济南'
                },{
                value: '西安',
                label: '西安'
                },{
                value: '呼和浩特',
                label: '呼和浩特'
                },{
                value: '沈阳',
                label: '沈阳'
                },{
                value: '长沙',
                label: '长沙'
                },{
                value: '鄂尔多斯',
                label: '鄂尔多斯'
                }
            ],
            recruitList:[
                {
                    title:'职位描述',
                    content:'',
                },
                {
                    title:'职位要求',
                    content:''
                }
            ],
            form:{
                name:'',
                classifyId:'',
                degree:'',
                jobCategory:'',
                experience:'',
                headcount:'',
                salaryRange:'',
                workplace:[]
            },
            options:'',
            options1:[
                {
                    id:1,
                    name:'初中及以下'
                },{
                    id:2,
                    name:'中专/中技'
                },{
                    id:3,
                    name:'高中'
                },{
                    id:4,
                    name:'大专'
                },{
                    id:5,
                    name:'本科'
                },{
                    id:6,
                    name:'硕士'
                },{
                    id:7,
                    name:'博士'
                }
            ],
            options2:[
                {
                    id:1,
                    name:'全职'
                },{
                    id:2,
                    name:'兼职'
                },
            ],
            options3:[
                {
                    id:1,
                    name:'在校生'
                },{
                    id:2,
                    name:'应届生'
                },{
                    id:3,
                    name:'1年以内'
                },{
                    id:4,
                    name:'1-3年'
                },{
                    id:5,
                    name:'3-5年'
                },{
                    id:6,
                    name:'5-10年'
                },{
                    id:7,
                    name:'10年以上'
                }
            ],
            options4:[
                 {
                    id:1,
                    name:'社招'
                },{
                    id:2,
                    name:'校招'
                },
            ],
            rules:{
            name: [{ required: true, message: '请输入岗位名称', trigger: 'blur' },
             { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
             ],
              classifyId: [{ required: true, message: '请选择人才分类', trigger: 'change' },],
              degree: [{ required: true, message: '请选择学历要求', trigger: 'change' },],
              jobCategory: [{ required: true, message: '请选择工作类型', trigger: 'change' },],
              experience: [{ required: true, message: '请选择经验要求', trigger: 'change' },],
              headcount:[{ required: true, message: '请输入招聘人数', trigger: 'blur' },],
              hiringNeeds: [{ required: true, message: '请选择招聘需求', trigger: 'change' },],
              salaryRange: [{ required: true, message: '请输入薪资范围', trigger: 'blur' },],
              workplace: [{ required: true, message: '请选择工作地点', trigger: 'change' },],
            }
        }
    },
    created () {
        // this.getjobClassify()       
        if(this.$route.query.id) this.getDetail()
    },
    mounted() {
        
    },
    methods: {
              classSelectType(){
           let checkStr = this.checkList.join(',')
           let num = ['1,2', '2,1'].includes(checkStr);
              let officialType = ''
               num ? officialType = "" : officialType = checkStr
               num ? officialType = "" : officialType = checkStr
              this.getjobClassify(officialType)
      }, 
        // 获取详情
        getDetail(){
             getJob(
                {id:this.$route.query.id},
                'get')
             .then(res => {
                this.form = {
                    name:res.data.name,
                    classifyId:res.data.classifyId,
                    degree:res.data.degree,
                    jobCategory:res.data.jobCategory,
                    experience:res.data.experience,
                    headcount:res.data.headcount,
                    hiringNeeds:res.data.hiringNeeds,
                    salaryRange:res.data.salaryRange,
                    workplace:res.data.workplace.split(',')
                }                        
                this.recruitList[0].content = res.data.description
                this.recruitList[1].content = res.data.requirement
                 let num = ['1,2', '2,1'].includes(res.data.officialType);
              let officialType = ''
               num ? officialType = "" : officialType = res.data.officialType
               num ? officialType = "" : officialType = res.data.officialType
              this.getjobClassify(officialType)
              this.checkList = res.data.officialType.split(',')
             })
             .catch(err => {})
        },
             // 子组件触发的方法
        emitFun(val,i,name){
        this.recruitList[i].content = val
        },
        // 城市
        cityValueChange(value){

        },
              // 获取分类
        getjobClassify(num){
         jobClassify({
                name:'',
            officialType:num
         })
         .then(res =>{
          if(res.code == 0){
            this.options = res.data
          }else{
            this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
          }
         })
         .catch(err =>{})
      },
        // 返回
        reback(){
            this.$router.push('/recruit')
        },
        // 保存
        onSubmit(formName){
         this.selectedOptions = []
           this.selectedOptions = this.form.workplace.join(',');
             let params = {
                name:this.form.name,
                classifyId:this.form.classifyId,
                degree:this.form.degree,
                jobCategory:this.form.jobCategory,
                experience:this.form.experience,
                hiringNeeds:this.form.hiringNeeds,
                headcount:this.form.headcount,
                workplace:this.selectedOptions,
                salaryRange:this.form.salaryRange,
                description:this.recruitList[0].content,
                requirement:this.recruitList[1].content
            }
            let method = "post"
            if(!this.$route.query.id) params = {...params},method = "post";
            if(this.$route.query.id) params = {...params,id:this.$route.query.id},method = "put";
             this.$refs[formName].validate((valid) => { 
                if(valid){
                     this.commentBness(params,method)
                }
              })
        },
         commentBness(params,method){
             this.loading = true
                editJob(params,method)
                        .then(res => {
                           if(res.code == 0){
                            this.loading = false
                            if(!this.$route.query.id)  this.$util.Notifi('新增成功','success','fa-check'); 
                           if(this.$route.query.id) this.$util.Notifi('修改成功','success','fa-check');
                          
                                setTimeout(() => {
                           this.$router.push("/recruit")
                             }, 100);
                           }else{
                             this.loading = false
                            this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
         }
    },
}
</script>
<style lang="scss" scoped>
 .edit-from{
         margin-bottom: 44px;
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 33%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        }
         }
         }
         .AppContent{
            margin-bottom: 100px;
         }
</style>